import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constants } from "./bank-holiday.abstract";
import { DataStoreService } from './data-store.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BankHolidaysService {
  londonBankHolidays;
  irelandBankHolidays;
  ignoreList = [
    'March Equinox', 'June Solstice', 'September Equinox', 'December Solstice', 'Christmas Eve', "New Year's Eve"
  ];

  constructor(
    private dataStore: DataStoreService,
    private http: HttpClient,
  ) { }

  async getIrelandsBankHolidays() {
    const requestUrl = `${Constants.REQUEST_URL}?${Constants.YEAR}=`;

    const headers = {
      'X-BL-TOKEN': `${environment.apiToken}`
    };

    const response = await this.http.post(`${requestUrl}${new Date().getFullYear()}`, {host: environment.environmentURL}, { headers }).toPromise();
    const nextYearResponse = await this.http.post(`${requestUrl}${new Date().getFullYear() + 1}`, {host: environment.environmentURL}, { headers }).toPromise();

    const irelandBankHolidays = response['response']['holidays'].concat(nextYearResponse['response']['holidays']);
    const finalIrelandBankHolidays = [];
    if (irelandBankHolidays.length > 0) {
      for (const h of irelandBankHolidays) {
        if (this.ignoreList.indexOf(h.name) === -1) {
          finalIrelandBankHolidays.push(h);
        }
      }
    }
    this.irelandBankHolidays = finalIrelandBankHolidays;
    return this.irelandBankHolidays;
  }

  async getUKBankHolidays() {
    const requestUrl = 'https://www.gov.uk/bank-holidays.json';

    const response = await this.http.get(requestUrl, {}).toPromise();
    const londonBankHolidays = response['england-and-wales']['events'];
    const finalLondonBankHolidays = [];
    if (londonBankHolidays.length > 0) {
      for (const h of londonBankHolidays) {
        if (this.ignoreList.indexOf(h.name) === -1) {
          finalLondonBankHolidays.push(h);
        }
      }
    }
    this.londonBankHolidays = finalLondonBankHolidays;
    return this.londonBankHolidays;
  }

  async getHolidays(id) {
    if (id === 37001 || id === 37002) {
      return this.irelandBankHolidays;
    } else {
      return this.londonBankHolidays;
    }
  }
}
